import React, { useEffect, useState, useMemo, useCallback } from 'react'
import fetchAPI from 'src/lib/utils/fetch-api'
import { Select } from 'antd'
import { getDataOfType } from 'src/lib/utils/get-data-of-type'

function filterOption(input, option){
  return option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

function SelectFrom({ value, schema, onChange, UISchema }:{ value?:any, schema?:any, onChange?:any, UISchema?:any }) {
  const disabled = useMemo(() => Boolean(UISchema?.options?.disabled), [UISchema])
  const [objects, setObjects] = useState<any[]>([{ id: value, value }])
  useEffect(() => {
    (async () => {
      const collectionName = 'regions';
      const objectsResult: any = await fetchAPI(`/api/collections/${collectionName}`)
        .then(item => getDataOfType(item, 'data.data', Array, []))
      const objectsFormat = objectsResult.map(item => {
        return { 
        id: getDataOfType(item, 'data.attributes.code', String, null), 
        value: getDataOfType(item, 'data.name', String, 
          getDataOfType(item, 'data.attributes.code', String, null)
        )}
      })
      .filter(item => item['id'])
      setObjects(objectsFormat)
    })()
  }, [])
  const values: any[] = useMemo(() =>  Array.isArray(value) ? value: [], [value])

  const onSearch = useCallback(text => {
    return text
  }, [])

  return (
    <Select
      onSearch={onSearch}
      mode="multiple"
      showSearch
      placeholder="Выберите запись"
      optionFilterProp="children"
      onChange={onChange}
      value={values}
      disabled={disabled}
      filterOption={filterOption}
    >
    {objects.map(({ id, value }) => (
      <Select.Option value={id}>{value}</Select.Option>
    ))}
    </Select>
  )
}

export default SelectFrom

